<template>
  <div class="page">
    <div class="banners">
      <img src="../assets/img/about/welfare_banner.jpg" alt="新闻动态" />
    </div>
    <section class="welfare">
      <div class="welfare-detail">
        <div class="detail">
          <h4 v-text="detail.title" class="title"></h4>
          <p v-text="detail.created_at" class="datetime"></p>
          <div class="line"></div>
          <div v-html="detail.contents"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "welfaredetail",
  data() {
    return {
      detail: {}
    };
  },
  created(){
    let arr = location.href.split("/");
    let curr_new = arr[arr.length - 1];
    let that = this;
    this.$ajax.get("/getWelfareDetail/" + curr_new).then(function(res) {
      that.detail = res.wfdetails;
    }).catch(error => {
      console.log(error);
    })
  },
  mounted() {
  },
  methods: {


  },
};
</script>

<style lang="scss" scoped>
.banners{
  height: 180px;
  >img{
    height: 100%;
  }
}
.welfare {
  .line{
    height: .1rem;
    width: 100%;
    background: rgb(245,245,245);
    margin: 1rem 0;
  }
  .title{
    color: #535353 !important;
  }
  .datetime{
    color: #999 !important;
    text-indent: 0 !important;
  }
  > p {
    color: #999 ;
    margin-bottom: 28px;
  }
  .welfare-detail {
    display: flex;
    .detail {
      flex: 1;
      padding: 1rem;
      img{
        width: 100% !important;
        height: 100% !important;
        user-select: none;
      }
      video{
        width: 100% !important;
      }
      > h4 {
        font-weight: 700;
        color: #333;
        margin-bottom: 1rem;
      }
      p{
        font-size: .6rem !important;
        color: #535353;
        padding: 5px 0;
        line-height: 2em;
        font-family: "helvetica";
      }
    }

  }
}


</style>



// WEBPACK FOOTER //
// src/page/welfaredetail.vue